export const getRecipeExportName = ({ recipe, selectedVariantId = null, recipeVariants = [] }) => {
  if (selectedVariantId === null) {
    return recipe.name;
  }

  const selectedVariant = recipeVariants.find(({ id }) => id === selectedVariantId);

  if (!selectedVariant?.name) {
    return recipe.name;
  }

  return `${recipe.name} (${selectedVariant.name})`;
};

export const downloadFileFromBase64 = (href, fileName, fileExtension) => {
  const link = document.createElement('a');

  link.href = href;
  link.setAttribute('download', !!fileExtension ? `${fileName}.${fileExtension}` : `${fileName}`);

  document.body.appendChild(link);

  link.click();
};

export default {
  downloadFileFromBase64,
};
